import { OptionChainScreens, OptionGraphErrorTypes, OptionGraphLoaderTypes, } from "@domains/features/Markets/Options/entites/iOptionChain";
var OptionsChainGraph = /** @class */ (function () {
    function OptionsChainGraph(actions, usecase) {
        this.actions = actions;
        this.usecase = usecase;
    }
    OptionsChainGraph.prototype.getScreenData = function (req) {
        switch (req.screen) {
            case OptionChainScreens.ALL:
                this.getAllOptionChainGraphData(req);
                break;
            case OptionChainScreens.CHART:
                this.getAllOptionChainChartGraphData(req);
                break;
            case OptionChainScreens.CHANGE:
                this.getAllOptionChainChangeGraphData(req);
                break;
            case OptionChainScreens.PAIN:
                this.getAllOptionChainPainGraphData(req);
                break;
        }
    };
    OptionsChainGraph.prototype.getAllOptionChainGraphData = function (req) {
        var _this = this;
        this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OI_CHANGE_ERROR);
        this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OI_CHART_ERROR);
        this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OPTION_PAIN_ERROR);
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OI_CHANGE_LOADER);
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OI_CHART_LOADER);
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OPTION_PAIN_LOADER);
        this.usecase.optionChain.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.optionGraphActions.updateGraphData(data);
                }
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHANGE_LOADER);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHART_LOADER);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_PAIN_LOADER);
                _this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OI_CHANGE_ERROR);
                _this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OI_CHART_ERROR);
                _this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OPTION_PAIN_ERROR);
            },
            onError: function (error) {
                _this.actions.optionGraphActions.setError({ isOpen: true, error: error }, OptionGraphErrorTypes.OI_CHANGE_ERROR);
                _this.actions.optionGraphActions.setError({ isOpen: true, error: error }, OptionGraphErrorTypes.OI_CHART_ERROR);
                _this.actions.optionGraphActions.setError({ isOpen: true, error: error }, OptionGraphErrorTypes.OPTION_PAIN_ERROR);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHANGE_LOADER);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHART_LOADER);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_PAIN_LOADER);
            },
        }, req);
    };
    OptionsChainGraph.prototype.getAllOptionChainChartGraphData = function (req) {
        var _this = this;
        this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OI_CHART_ERROR);
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OI_CHART_LOADER);
        this.usecase.optionChain.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.optionGraphActions.updateOIChangeGraphData(data);
                }
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHART_LOADER);
            },
            onError: function (error) {
                _this.actions.optionGraphActions.setError({ isOpen: true, error: error }, OptionGraphErrorTypes.OI_CHART_ERROR);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHART_LOADER);
            },
        }, req);
    };
    OptionsChainGraph.prototype.getAllOptionChainChangeGraphData = function (req) {
        var _this = this;
        this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OI_CHANGE_ERROR);
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OI_CHANGE_LOADER);
        this.usecase.optionChain.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.optionGraphActions.updateOIChartGraphData(data);
                }
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHANGE_LOADER);
            },
            onError: function (error) {
                _this.actions.optionGraphActions.setError({ isOpen: true, error: error }, OptionGraphErrorTypes.OI_CHANGE_ERROR);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OI_CHANGE_LOADER);
            },
        }, req);
    };
    OptionsChainGraph.prototype.getAllOptionChainPainGraphData = function (req) {
        var _this = this;
        this.actions.optionGraphActions.hideError(OptionGraphErrorTypes.OPTION_PAIN_ERROR);
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OPTION_PAIN_LOADER);
        this.usecase.optionChain.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.optionGraphActions.updateOIChangeGraphData(data);
                }
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_PAIN_LOADER);
            },
            onError: function (error) {
                _this.actions.optionGraphActions.setError({ isOpen: true, error: error }, OptionGraphErrorTypes.OPTION_PAIN_ERROR);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_PAIN_LOADER);
            },
        }, req);
    };
    return OptionsChainGraph;
}());
export default OptionsChainGraph;
